module.exports = __webpack_public_path__ + "img/05.b20d57eb.jpg";